import {debounce} from "./debounce";

const scrollObserver = (
        {
            items,
            rootMargin = "-250px 0px",
            threshold = 0.02,
            targetClass = "animated",
        },
        callback = false
    ) => {

    if (!items || items.length === 0) return;

    let options = {
        root: null,
        rootMargin,
        threshold,
    };

    let observer = new IntersectionObserver(beTouching, options);
    items.forEach(item => observer.observe(item));

    // Handle Items Intersecting
    function beTouching(entries, ob) {
        entries.forEach((entry) => {
            if (callback) {
                callback(entry);
                return;
            }

            if (entry.isIntersecting) {
                entry.target.classList.add(targetClass);
                if (!entry.target.classList.contains('both-direction')) ob.unobserve(entry.target);
            } else {
                entry.target.classList.remove(targetClass);
            }
        });
    }
}

export default scrollObserver;
